import {
  Get_Error,
  GetAllMeetingCommentsByUser_Type,
  GetAllMeetingCommentsForoneuser_Type,
  GetAllMettingsheetForAdmin_type,
} from '../Types';

const intial = {
  MeetingComments: [],

  loading: true,
};
export const MeetingCommentsReducer = (state = intial, action) => {
  switch (action.type) {
    case GetAllMeetingCommentsForoneuser_Type:
      return {
        MeetingComments: action.payload,
        loading: false,
      };

    case GetAllMeetingCommentsByUser_Type:
      return {
        MeetingComments: action.payload,
        loading: false,
      };

    case GetAllMettingsheetForAdmin_type:
      return {
        MeetingComments: action.payload,
        loading: false,
      };
    case Get_Error:
      return {
        loading: true,
        MeetingComments: action.payload,
      };
    default:
      return state;
  }
};
